<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Bloques</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operacion</li>
                  <li class="breadcrumb-item active">Bloques</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ id ? "Editar" : "Crear" }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-3 pt-2 pb-2">
                <h5 class="mb-0">
                  Formulario {{ id ? "Editar" : "Crear" }} Bloques
                </h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Sitios"
                    data-toggle="tab"
                    href="#Sitios"
                    v-if="id"
                    >Sitios</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Geocercas"
                    data-toggle="tab"
                    href="#Geocercas"
                    @click="$refs.BloqueGeocerca.getIndex()"
                    v-if="form.id"
                    >Geocercas</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="form-group col-md-5">
                        <label for="nombre">Nombre Bloque</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          id="nombre"
                          v-model="form.nombre"
                          :class="
                            $v.form.nombre.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="prefijo">Prefijo</label>
                        <input
                          type="text"
                          maxlength="3"
                          class="form-control form-control-sm"
                          id="prefijo"
                          v-model="form.prefijo"
                          :class="
                            $v.form.prefijo.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="codigo">Código</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          id="codigo"
                          v-model="form.codigo"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="pais">Pais</label>
                        <v-select
                          id="pais"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                            $v.form.pais_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                          ]"
                          v-model="form.pais_id"
                          label="nombre"
                          :options="listasForms.paises"
                          @input="filtrarDepartamentos()"
                          :reduce="(p) => p.id"
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label for="departamento">Departamento</label>
                        <v-select
                          id="departamento"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                            $v.form.departamento_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                          ]"
                          v-model="form.departamento_id"
                          label="descripcion"
                          :options="listasForms.departamentos"
                          @input="filtrarCiudades()"
                          :reduce="(d) => d.id"
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label for="ciudad">Ciudad</label>
                        <v-select
                          id="ciudad"
                          class="form-control form-control-sm p-0"
                          :class="[
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                            $v.form.ciudad_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                          ]"
                          v-model="form.ciudad_id"
                          label="nombre"
                          :options="listasForms.ciudades"
                          :reduce="(c) => c.id"
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label for="direccion">Dirección</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          id="direccion"
                          v-model="form.direccion"
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label for="estado">Estado</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.estado"
                          disabled
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.id"
                            :value="estado.id"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>Justificación Inactivación</label>
                        <textarea
                          class="form-control form-control-sm"
                          v-model="form.justificacion"
                          disabled
                        >
                        </textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="Sitios" v-if="id">
                  <div class="card-body" v-show="!$v.form.$invalid">
                    <BloqueSitios ref="BloqueSitios" />
                  </div>
                </div>
                <div class="tab-pane fade" id="Geocercas" v-if="form.id">
                  <div class="card-body">
                    <BloqueGeocerca ref="BloqueGeocerca" />
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <button
                    class="btn bg-primary col-md-1"
                    v-show="!$v.form.$invalid"
                    @click="save()"
                    v-if="
                      $store.getters.can('admin.bloques.create') ||
                      $store.getters.can('admin.bloques.edit')
                    "
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";
import BloqueGeocerca from "./BloqueGeocerca.vue";
import BloqueSitios from "./BloqueSitios.vue";

export default {
  name: "BloqueForm",

  components: {
    Loading,
    vSelect,
    BloqueGeocerca,
    BloqueSitios,
  },

  data() {
    return {
      cargando: false,
      id: this.$route?.params?.id ?? null,
      form: {
        id: null,
        nombre: null,
        prefijo: null,
        codigo: null,
        pais_id: null,
        departamento_id: null,
        ciudad_id: null,
        direccion: null,
        justificacion: null,
        estado: 1,
      },
      listasIniciales: {
        departamentos: [],
        ciudades: [],
      },
      listasForms: {
        paises: [],
        departamentos: [],
        ciudades: [],
        sitios: [],
        estados: [],
      },
      modal: {
        title: "",
        accion: "",
      },
    };
  },

  validations: {
    form: {
      nombre: {
        required,
      },
      pais_id: {
        required,
      },
      departamento_id: {
        required,
      },
      ciudad_id: {
        required,
      },
      prefijo: {
        required,
      },
    },
  },

  methods: {
    getIndex() {
      if (this.id) {
        this.resetForm();
        axios({
          method: "GET",
          url: "/api/admin/bloques/show/" + this.id,
        })
          .then((result) => {
            this.cargando = false;
            this.form = result.data;
            // Se toma el valor de las listas de de[partamento y ciudad
            this.listasForms.departamentos =
              this.listasIniciales.departamentos.filter(
                (d) => d.id === this.form.departamento_id
              );
            this.listasForms.ciudades = this.listasIniciales.ciudades.filter(
              (c) => c.id === this.form.ciudad_id
            );
            this.$refs.BloqueSitios.getIndex();
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    resetForm() {
      this.sitios = [];
      this.form = {
        id: null,
        nombre: null,
        prefijo: null,
        codigo: null,
        pais_id: null,
        departamento_id: null,
        ciudad_id: null,
        direccion: null,
        justificacion: null,
        estado: 1,
      };
      this.formSitios = {
        id: null,
        bloque_id: this.id,
      };
    },
    getPaises() {
      axios.get("/api/admin/paises/lista").then((response) => {
        this.listasForms.paises = response.data;
      });
    },
    getDepartamentos() {
      axios.get("/api/admin/departamentos/lista").then((response) => {
        this.listasIniciales.departamentos = response.data;
      });
    },
    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasIniciales.ciudades = response.data;
      });
    },
    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    getSitios() {
      axios.get("/api/admin/sitios/lista").then((response) => {
        this.listasForms.sitios = response.data;
      });
    },
    filtrarDepartamentos() {
      this.listasForms.departamentos = [];
      this.form.departamento_id = null;
      this.listasForms.ciudades = [];
      this.form.ciudad_id = null;
      if (this.form.pais_id) {
        this.listasForms.departamentos =
          this.listasIniciales.departamentos.filter(
            (dep) => dep.pais_id === this.form.pais_id
          );
      }
    },
    filtrarCiudades() {
      this.listasForms.ciudades = [];
      this.form.ciudad_id = null;
      if (this.form.departamento_id) {
        this.listasForms.ciudades = this.listasIniciales.ciudades.filter(
          (ciu) => ciu.departamento_id === this.form.departamento_id
        );
      }
    },
    save() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        axios({
          method: this.id ? "PUT" : "POST",
          url: "/api/admin/bloques",
          data: this.form,
        })
          .then((response) => {
            this.id = response.data.id;
            this.cargando = false;
            this.$swal({
              icon: "success",
              title: "Los datos se guardaron exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.getIndex();
            // return this.$router.push({
            //   name: "/Admin/Bloques",
            //   params: { msg: "El Bloque se guardó exitosamente..." },
            // });
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    back() {
      return this.$router.replace("/Admin/Bloques");
    },
  },

  beforeMount() {
    this.getEstados();
    this.getPaises();
    this.getDepartamentos();
    this.getCiudades();
    this.getSitios();
  },

  mounted() {
    this.getIndex();
  },
};
</script>
